// extracted by mini-css-extract-plugin
export default {"timeCardIcon":"Timetable_timeCardIcon__604Ji","iconDiv":"Timetable_iconDiv__HWzcI"};